var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('img',{staticClass:"bg-img",attrs:{"src":_vm.backImg,"alt":""}}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('p',[_vm._v("더 나은 서비스를 위해 사이트를 개선하고 있습니다.")])])
}]

export { render, staticRenderFns }